import AppConfigs from 'general/constants/AppConfigs';
import axiosClient from './axiosClient';

const feApi = {
  // lay thong tin chi tiet voi sac
  getChargeConnectorDetail: (chargeConnectorId) => {
    const url = `/fe/connector/${chargeConnectorId}`;
    return axiosClient.get(url, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  activateChargeByQR: (params = {}) => {
    const url = '/fe/activateChargerByQR';
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  deactivateCharge: (params = {}) => {
    const url = '/fe/deactivateCharger';
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  checkPaymentStatus: (params = {}) => {
    const url = '/fe/payment';
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  getBrandList: (params = {}) => {
    const url = '/fe/carBrands';
    return axiosClient.get(url, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  getModelList: (params = {}) => {
    const url = '/fe/carModels';
    return axiosClient.get(url, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  // quen mat khau
  requestForgotPassword: (email) => {
    const url = '/fe/forgot';
    const params = {
      email: email,
    };
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  // dat lai mat khau
  resetPassword: (email, token, newPassword) => {
    const url = '/fe/reset';
    const params = {
      email,
      token,
      newPassword,
    };
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  getTransactionDetail: (params = {}) => {
    const url = '/fe/transaction';
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  // lay thong tin chi tiet the rfid
  getTopupCard: (params) => {
    const url = `/fe/getTopupCard`;
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  // nap tien qua ma qr
  topupCard: (params) => {
    const url = `/fe/topupCard`;
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },
};

export default feApi;
